import Phaser from "phaser";
import BootScene from "./scenes/BootScene";
import BattleScene from "./scenes/BattleScene";
import ResultScene from "./scenes/ResultScene";

// Pixel font: латинский + кириллический subset'ы Press Start 2P (Fontsource).
import "@fontsource/press-start-2p/latin.css";
import "@fontsource/press-start-2p/latin-ext.css";
import "@fontsource/press-start-2p/cyrillic.css";
import "@fontsource/press-start-2p/cyrillic-ext.css";

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: "game",
  width: 480,
  height: 270,
  pixelArt: true,
  backgroundColor: "#000000",
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  scene: [BootScene, BattleScene, ResultScene],
};

/**
 * Дожидаемся загрузки и латиницы, и кириллицы Press Start 2P до запуска
 * Phaser. Иначе первая отрисовка текста уйдёт в monospace fallback и
 * закешируется в текстуре.
 */
async function start(): Promise<void> {
  if (document.fonts) {
    try {
      await Promise.all([
        document.fonts.load('8px "Press Start 2P"', "ABC АБВ"),
        document.fonts.load('16px "Press Start 2P"', "ABC АБВ"),
      ]);
    } catch {
      // не критично — fallback monospace всё равно покажется
    }
  }
  new Phaser.Game(config);
}

void start();

// TODO: добавить звук/музыку (фоновая тема боя, SFX команд, hurt-flash, KO).
